import { render, staticRenderFns } from "./applyidcard.vue?vue&type=template&id=ddeb9ada&scoped=true&"
import script from "./applyidcard.vue?vue&type=script&lang=js&"
export * from "./applyidcard.vue?vue&type=script&lang=js&"
import style0 from "./applyidcard.vue?vue&type=style&index=0&id=ddeb9ada&less=true&scoped=true&lang=css&"
import style1 from "./applyidcard.vue?vue&type=style&index=1&less=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddeb9ada",
  null
  
)

export default component.exports